import { useEffect, useState } from "react";

export type PartnerLogo = {
  id: number | string;
  name: string;
  logoUrl: string;
  websiteUrl: string;
};

type PartnerLogoApiResponse = {
  partners: Array<{
    id: number;
    name: string;
    logo_url: string;
    website_url: string;
  }>;
};

export const SAMPLE_PARTNER_LOGOS: PartnerLogo[] = [
  {
    id: "sample-aurelis",
    name: "Aurelis",
    logoUrl: "/static/venuex/partners/aurelis.svg",
    websiteUrl: "",
  },
  {
    id: "sample-north",
    name: "North & Co.",
    logoUrl: "/static/venuex/partners/north-co.svg",
    websiteUrl: "",
  },
  {
    id: "sample-kalon",
    name: "Kalon",
    logoUrl: "/static/venuex/partners/kalon.svg",
    websiteUrl: "",
  },
  {
    id: "sample-atelier",
    name: "Atelier Twenty Two",
    logoUrl: "/static/venuex/partners/atelier-22.svg",
    websiteUrl: "",
  },
  {
    id: "sample-nocturne",
    name: "Nocturne",
    logoUrl: "/static/venuex/partners/nocturne.svg",
    websiteUrl: "",
  },
  {
    id: "sample-atlas",
    name: "Atlas House",
    logoUrl: "/static/venuex/partners/atlas-house.svg",
    websiteUrl: "",
  },
];

export function usePartnerLogos() {
  const [partners, setPartners] = useState<PartnerLogo[]>(SAMPLE_PARTNER_LOGOS);

  useEffect(() => {
    const controller = new AbortController();

    fetch("/api/partner-logos/", {
      headers: { Accept: "application/json" },
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load VenueX partner logos");
        }
        return response.json() as Promise<PartnerLogoApiResponse>;
      })
      .then((data) => {
        setPartners(
          data.partners.map((partner) => ({
            id: partner.id,
            name: partner.name,
            logoUrl: partner.logo_url,
            websiteUrl: partner.website_url,
          })),
        );
      })
      .catch((error: unknown) => {
        if (!(error instanceof DOMException && error.name === "AbortError")) {
          setPartners(SAMPLE_PARTNER_LOGOS);
        }
      });

    return () => controller.abort();
  }, []);

  return partners;
}
